import { matchPath } from "react-router-dom";
import { List, ListSubheader } from "@material-ui/core";
import NavItem from "./NavItem";
import { useTranslation } from "react-i18next";

const renderNavItems = ({ depth = 0, items, pathname, t }) => (
  <List disablePadding>
    {items.reduce(
      // eslint-disable-next-line no-use-before-define
      (acc, item) =>
        reduceChildRoutes({
          acc,
          item,
          pathname,
          depth,
          t,
        }),
      []
    )}
  </List>
);

const reduceChildRoutes = ({ acc, pathname, item, depth, t }) => {
  const key = `${item.title}-${depth}`;
  const exactMatch = item.path
    ? !!matchPath(
        {
          path: !item.path.startsWith("/dashboard")
            ? `/dashboard/${item.path}`
            : item.path,
          end: true,
        },
        pathname
      )
    : false;

  if (item.children) {
    const partialMatch = item.path
      ? !!matchPath(
          {
            path: !item.path.startsWith("/dashboard")
              ? `/dashboard/${item.path}`
              : item.path,
            end: false,
          },
          pathname
        )
      : false;

    acc.push(
      <NavItem
        active={partialMatch}
        depth={depth}
        icon={item.icon}
        info={item.info}
        key={key}
        open={partialMatch}
        path={item.path}
        title={t(`title.${item.title}`)}
      >
        {renderNavItems({
          depth: depth + 1,
          items: item.children,
          pathname,
          t,
        })}
      </NavItem>
    );
  } else {
    acc.push(
      <NavItem
        active={exactMatch}
        depth={depth}
        icon={item.icon}
        info={item.info}
        key={key}
        path={item.path}
        title={t(`title.${item.title}`)}
      />
    );
  }

  return acc;
};

const NavSection = (props: any) => {
  const { t } = useTranslation();
  const { items, pathname, title, ...other } = props;

  return (
    <List
      subheader={
        <ListSubheader
          disableGutters
          disableSticky
          sx={{
            color: "text.primary",
            fontSize: "0.75rem",
            lineHeight: 2.5,
            fontWeight: 700,
            textTransform: "uppercase",
          }}
        >
          {title}
        </ListSubheader>
      }
      {...other}
    >
      {renderNavItems({
        items,
        pathname,
        t,
      })}
    </List>
  );
};

export default NavSection;
